import {StyledAccessesValidatorsList, StyledVirtualList} from './style'
import {useGetSignatureSheets} from '../../queries/useGetSignatureSheets'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {ValidatorSearchParams} from '../../types'
import {AccessesValidatorListItem} from '../accesses-validators-list-item/AccessesValidatorListItem'
import dayjs from 'dayjs'
import {forwardRef} from 'react'
import {AccessesValidatorSkeleton} from '@/pages/accesses-validator/AccessesValidatorSkeleton'
import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {AccessesValidatorsEmptyState} from '../accesses-validators-empty-state/AccessesValidatorsEmptyState'
import {useTranslation} from '@/translations/i18n'

export const AccessesValidatorsList = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(ValidatorSearchParams)
    const {
        data: signatureSheets,
        isLoading,
        isError
    } = useGetSignatureSheets(
        {
            consultant: searchParams.consultant ?? '',
            startDate: searchParams.startDate ? dayjs(searchParams.startDate).format('YYYY-MM-DD') : undefined,
            endDate: searchParams.endDate ? dayjs(searchParams.endDate).format('YYYY-MM-DD') : undefined,
            patient: searchParams.patient
        },
        {
            enabled: !!searchParams.consultant
        }
    )

    if (isLoading) {
        return <AccessesValidatorSkeleton />
    }

    if (isError) {
        return <ErrorBox icon={<AlertTriangleIcon />} title={t('errors:default')} />
    }

    if (!signatureSheets) {
        return <AccessesValidatorsEmptyState />
    }

    return (
        <StyledVirtualList
            totalCount={signatureSheets?.length ?? 0}
            overscan={100}
            data={signatureSheets ?? []}
            itemContent={(index, data) => <AccessesValidatorListItem key={index} signatureSheet={data} />}
            components={{
                List: forwardRef((props, ref) => <StyledAccessesValidatorsList {...props} ref={ref} />)
            }}
        />
    )
}
